import { createSelector } from 'reselect';

import { NavmenuProps } from '@/components/atomic/templates/navigation/navmenu/typings';
import getModels from '@/state/selectors/navigation/get-models';
import { Constants } from '@adobe/aem-spa-page-model-manager';

const { ITEMS_PROP, ITEMS_ORDER_PROP } = Constants;

const getDynamicRenditionsConfig = createSelector([getModels], (models) => {
	const modelsList = Object.values(models);

	let dxDynamicMediaRenditionsConfig:
		| NavmenuProps['dxDynamicMediaRenditionsConfig']
		| undefined;

	for (const model of modelsList) {
		const modelItems = model[ITEMS_PROP];
		if (!modelItems) return null;

		const modelItemsOrder = model[ITEMS_ORDER_PROP];
		if (!modelItemsOrder || modelItemsOrder.length === 0) return null;

		const rootComponentKey = modelItemsOrder.find((componentKey) =>
			componentKey.startsWith('root'),
		);
		if (!rootComponentKey) return null;

		const rootComponent = modelItems?.[rootComponentKey];
		if (!rootComponent) return null;

		const rootItems = rootComponent[ITEMS_PROP];
		if (!rootItems) return null;

		const rootItemsOrder = rootComponent[ITEMS_ORDER_PROP];
		if (!rootItemsOrder || rootItemsOrder.length === 0) return null;

		const navMenuComponentKey = rootItemsOrder.find((componentKey) =>
			componentKey.startsWith('navmenu'),
		);
		if (!navMenuComponentKey) return null;

		const navMenuComponent = rootItems?.[navMenuComponentKey];
		if (!navMenuComponent) return null;

		if ((navMenuComponent as NavmenuProps).dxDynamicMediaRenditionsConfig) {
			dxDynamicMediaRenditionsConfig = (navMenuComponent as NavmenuProps)
				.dxDynamicMediaRenditionsConfig;
			break;
		}
	}

	return dxDynamicMediaRenditionsConfig;
});

export default getDynamicRenditionsConfig;
